const Google = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22.5012 12.2332C22.5012 11.3699 22.4297 10.7399 22.275 10.0865H12.2155V13.9832H18.1202C18.0012 14.9515 17.3583 16.4099 15.9297 17.3898L15.9097 17.5203L19.0903 19.935L19.3107 19.9565C21.3344 18.1249 22.5012 15.4298 22.5012 12.2332Z'
        fill='#4285F4'
      />
      <path
        d='M12.2147 22.5C15.1075 22.5 17.5361 21.5666 19.3099 19.9567L15.929 17.3899C15.0242 18.0083 13.8099 18.4399 12.2147 18.4399C9.38142 18.4399 6.97669 16.6083 6.11947 14.0766L5.99382 14.0871L2.68656 16.5954L2.64331 16.7132C4.40519 20.1433 8.02423 22.5 12.2147 22.5Z'
        fill='#34A853'
      />
      <path
        d='M6.1201 14.0766C5.89391 13.4233 5.76301 12.7232 5.76301 11.9999C5.76301 11.2765 5.89391 10.5766 6.1082 9.92325L6.1022 9.78411L2.75349 7.23547L2.64393 7.28655C1.91777 8.7099 1.5011 10.3083 1.5011 11.9999C1.5011 13.6916 1.91777 15.2899 2.64393 16.7132L6.1201 14.0766Z'
        fill='#FBBC05'
      />
      <path
        d='M12.2148 5.55997C14.2267 5.55997 15.5838 6.41163 16.3576 7.12335L19.3814 4.23C17.5243 2.53834 15.1076 1.5 12.2148 1.5C8.02426 1.5 4.4052 3.85665 2.64331 7.28662L6.10759 9.92332C6.97672 7.39166 9.38146 5.55997 12.2148 5.55997Z'
        fill='#EB4335'
      />
    </svg>
  );
};

export default Google;
